const styles = {
  button: {
    backgroundColor: 'background.white',
  },
  root: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 99,
    width: '100%',
    paddingY: 2,
    transition: 'all 0.5s ease',
    height: 80,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    flexDirection: 'column',
    '& .Categories-root': {
      opacity: 0,
    },
    '&.open': {
      height: '150px',
      transition: 'all 0.3s ease-in',
      backgroundColor: 'rgba(255,255,255,0.6)',
      '& .Categories-root': {
        opacity: 1,
      },
    },
  },

  categoriesContainer: {
    overflow: 'hidden',
    paddingX: 2,
  },

  iconContainer: {
    position: 'relative',
    width: { xs: 20, lg: 25 },
    height: { xs: 20, lg: 25 },
  },

  filtercontainer: {
    display: 'flex',
    overflowX: 'scroll',
    overflowY: 'none',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    gap: 2,
    paddingX: 1,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&::-webkit-scrollbar:horizontal': {
      display: 'none',
    },
    '&::-webkit-scrollbar:vertical': {
      display: 'none',
    },
    '&::-webkit-scrollbar-track': {
      display: 'none',
    },
  },

  categoryCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

}

export default styles
